import { isMacOs, isWindows } from "react-device-detect";


export const platform = isMacOs ? 'darwin' : isWindows? 'win32' : "linux"